<template>
  <div>
    <v-row class="pr-5 pb-3 mt-5">
      <v-col class="d-flex justify-content-start">
        <v-btn color="success" @click="openAddModal">
          تقديم طلب إجازة <v-icon right>mdi-calendar-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-card min-width="80%" class="mx-auto ma-3">
      <v-card-title>
        سجل الإجازات - {{ branchName }}
        <v-spacer />
        <v-text-field v-model="search" append-icon="mdi-magnify" label="بحث" single-line hide-details />
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="leaves"
        :loading="loading"
        :search="search"
        class="elevation-1"
        :footer-props="{
          'items-per-page-text': 'عدد الطلبات',
        }">
        <template v-slot:[`item.startDate`]="{ item }">
          {{ formatDate(item.startDate) }}
        </template>
        <template v-slot:[`item.applyDate`]="{ item }">
          {{ formatDate(item.applyDate) }}
        </template>
        <template v-slot:[`item.endDate`]="{ item }">
          {{ formatDate(item.endDate) }}
        </template>
        <template v-slot:[`item.isApprove`]="{ item }">
          <v-chip :color="getStatusColor(item.isApprove)" dark small>
            {{ getStatusText(item.isApprove) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <!-- Add Leave Modal -->
    <v-dialog v-model="dialog" width="600" persistent>
      <v-card>
        <v-form v-model="valid" ref="form">
          <v-card-title class="headline grey lighten-2">
            تقديم طلب إجازة جديد
          </v-card-title>
          <v-card-text class="mt-4">
            <v-container>
              <v-row dense>
                <v-col cols="12">
                  <v-autocomplete
                    label="الموظف"
                    :items="employees"
                    item-text="name"
                    item-value="id"
                    v-model="newLeave.employeeId"
                    :rules="[v => !!v || 'يرجى اختيار الموظف']"
                    outlined
                    dense />
                </v-col>
                <v-col cols="12">
                  <v-select
                    label="نوع الإجازة"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    v-model="newLeave.leaveCategoryId"
                    :rules="[v => !!v || 'يرجى اختيار نوع الإجازة']"
                    outlined
                    dense />
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newLeave.startDate"
                        label="من تاريخ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[v => !!v || 'مطلوب']" />
                    </template>
                    <v-date-picker v-model="newLeave.startDate" @input="menu1 = false" />
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="newLeave.endDate"
                        label="إلى تاريخ"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :rules="[v => !!v || 'مطلوب']" />
                    </template>
                    <v-date-picker v-model="newLeave.endDate" @input="menu2 = false" />
                  </v-menu>
                </v-col>
                <v-col cols="12">
                  <v-textarea label="السبب" v-model="newLeave.reason" outlined dense rows="3" />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn color="grey darken-1" text @click="dialog = false">إلغاء</v-btn>
            <v-btn color="primary" :disabled="!valid" @click="submitLeave" :loading="submitting">إرسال الطلب</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LeaveService from "../services/LeaveService";

export default {
  name: "LeaveRequest",
  data() {
    return {
      loading: false,
      submitting: false,
      dialog: false,
      valid: false,
      search: "",
      menu1: false,
      menu2: false,
      leaves: [],
      categories: [],
      employees: [],
      newLeave: {
        employeeId: null,
        leaveCategoryId: null,
        startDate: null,
        endDate: null,
        reason: "",
        branchId: null
      },
      headers: [
        { text: "الموظف", value: "employeeName" },
        { text: "الرقم الوظيفي", value: "enrollNo" },
        { text: "من تاريخ", value: "startDate" },
        { text: "إلى تاريخ", value: "endDate" },
        { text: "الأيام", value: "totalDay" },
        { text: "الحالة", value: "isApprove" },
        { text: "تاريخ التقديم", value: "applyDate" }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    branchId() {
      // Assuming cityId is used as branch identifier in this system
      return this.user?.cityId;
    },
    branchName() {
      return this.user?.city?.name || "الفرع";
    }
  },
  async mounted() {
    console.log("LeaveRequest mounted. BranchId:", this.branchId);
    if (this.branchId) {
      this.loadData();
    } else {
      console.warn("No BranchId found for current user.");
    }
  },
  methods: {
    async loadData() {
      console.log("Loading leave data for branch:", this.branchId);
      this.loading = true;
      try {
        const [leavesResp, catsResp, empsResp] = await Promise.all([
          LeaveService.getLeavesByBranch(this.branchId),
          LeaveService.getCategories(),
          LeaveService.getEmployees(this.branchId)
        ]);
        this.leaves = leavesResp.data;
        this.categories = catsResp.data;
        this.employees = empsResp.data;
      } catch (error) {
        this.$dialog.notify.error("حدث خطأ أثناء تحميل البيانات");
      } finally {
        this.loading = false;
      }
    },
    openAddModal() {
      this.newLeave = {
        employeeId: null,
        leaveCategoryId: null,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10),
        reason: "",
        branchId: this.branchId
      };
      this.dialog = true;
    },
    async submitLeave() {
      if (!this.$refs.form.validate()) return;

      this.submitting = true;
      try {
        await LeaveService.addLeave(this.newLeave);
        this.$dialog.notify.success("تم تقديم طلب الإجازة بنجاح");
        this.dialog = false;
        this.loadData();
      } catch (error) {
        this.$dialog.notify.error("حدث خطأ أثناء تقديم الطلب");
      } finally {
        this.submitting = false;
      }
    },

    getStatusColor(status) {
      if (status === true) return "success";
      if (status === false) return "error";
      return "warning";
    },
    getStatusText(status) {
      if (status === true) return "معتمد";
      if (status === false) return "مرفوض";
      return "قيد الانتظار";
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .theme--light.v-list-item {
  color: rgba(0, 0, 0, 0.87) !important;
  text-align: right !important;
}
</style>
